/**
 * View component for /my-agenda/pending
 *
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import Base from '../../../global/components/BaseComponent.js.jsx';
import StudyLayout from '../../study/components/StudyLayout.js.jsx';

// import components 
import AgendaTmCard from '../components/AgendaTmCard.js.jsx';
// not updating links here because this should no longer be used with london handling agenda


class PendingAgenda extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // old page - redirect to london certs view just in case
    window.location.replace(`${window.agendaUrl}/certificates`);
    
    dispatch(contentModuleActions.fetchListIfNeeded('agenda-status', 'pending-attestation'));
  }

  render() {
    const { contentModuleStore } = this.props;

    const pendingList = contentModuleStore.lists['agenda-status'] ? contentModuleStore.lists['agenda-status']['pending-attestation'] : {};
    // const pendingItems = contentModuleStore.util.getList('agenda-status', 'pending-attestation');
    
    const pendingItems = pendingList ? pendingList.agendaItems : [];
    // console.log(pendingItems)
    
    const isEmpty = (
      !pendingItems
      || pendingItems.length === 0
    )

    const isFetching = (
      !pendingList
      || pendingList.isFetching
    )
    return(
      <StudyLayout>
        <Helmet
          title={"Pending Training |Pro-ficiency"}
        />
        <div className="flex">
          <section className="section my-agenda -program">
            <div className="-content-wrapper">
              <div className="-header">
                <h2>Training pending attestation</h2>
              </div>
              <hr/>
              { isEmpty ?
                (isFetching ?
                  <div className="u-centerText">
                    <div className="loading"></div>
                  </div>
                :
                  <div className="u-centerText">
                    <h2>No pending training found!</h2>
                    <p>Please <Link to="/contact-us">contact</Link> your administrator if you feel this was an error.</p>
                    <p>Or navigate back to your <Link to="/my-agenda">Agenda</Link></p>
                  </div>
                )
                :
                <div style={{ opacity: isFetching ? 0.5 : 1 }}>
                  <div className="yt-row">
                    {pendingItems.map((agendaItem, i) => 
                      <AgendaTmCard
                        agendaItem={agendaItem}
                        key={'optInc_' + agendaItem._contentModule + '_' +i }
                        contentModule={contentModuleStore.byId[agendaItem._contentModule]}
                      /> 
                    )}
                  </div>
                </div>
              }
            </div>
          </section>
        </div>
      </StudyLayout>
    )
  }
}


PendingAgenda.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    contentModuleStore: store.contentModule
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(PendingAgenda)
);



// WEBPACK FOOTER //
// modules/agenda/views/PendingAgenda.js.jsx